import React from 'react';
import ImportMainContent from './ImportMainContent';
import ImportSideSection from './ImportSideSection';

const ImportDetails: React.FC = () => (
  <div className="flex flex-row w-full">
    <ImportMainContent />
    <div className="mt-4 flex-1 border-r border-litlingo-gray-2" />
    <ImportSideSection />
  </div>
);

export default ImportDetails;
